document
  .getElementById("make_filter")
  .addEventListener("change", async function () {
    var selectedMake = this.value;
    var modelSelect = document.getElementById("model_filter");
    modelSelect.disabled = true;
    if (!selectedMake) return;

    const query = `
        query Facets {
            collection(handle: "${selectedMake}") {
                handle
                products(first: 250) {
                    filters {
                        id
                        label
                        type
                        values {
                            id
                            label
                            count
                            input
                        }
                    }
                }
            }
        }`;

    async function fetchFilters(query) {
      const filtersResponse = await fetch("/api/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "Access-Control-Origin": "*",
          "X-Shopify-Storefront-Access-Token":
            "d3021029f8d76cfe263c16528e4fb3b3",
        },
        body: query,
      });
      const filterData = await filtersResponse.json();
      return Promise.resolve(
        filterData.data.collection.products.filters
          .flatMap((filter) => {
            return filter.id == "filter.p.m.filters.model" ? filter.values : [];
          })
          .filter((f) => f.count > 0)
      );
    }
    const filterModelRaw = await fetchFilters(query);
    const filterModel = filterModelRaw.filter(value => value.label !== 'NULL');
    if (filterModel.length === 0) {
      modelSelect.disabled = true;
      return;
    }
    modelSelect.innerHTML = '<option value="">Model</option>';
    filterModel.forEach(function (model) {
      var option = document.createElement("option");
      option.value = model.label;
      option.textContent = model.label;
      modelSelect.appendChild(option);
    });
    modelSelect.disabled = false;
  });

document
  .getElementById("model_filter")
  .addEventListener("change", async function () {
    var selectedMake = document.getElementById("make_filter").value;
    var selectedModel = this.value;
    var yearSelect = document.getElementById("year_filter");
    yearSelect.disabled = true;
    if (!selectedModel) return;
    const query = `
        query Facets {
            collection(handle: "${selectedMake}") {
                handle
                products(first: 250, filters: {
                    productMetafield: {
                        namespace: "filters",
                        key: "model",
                        value: "${selectedModel}"
                    }
                }) {
                    filters {
                        id
                        label
                        type
                        values {
                            id
                            label
                            count
                            input
                        }
                    }
                }
            }
        }`;

    async function fetchFilters(query) {
      const filtersResponse = await fetch("/api/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "Access-Control-Origin": "*",
          "X-Shopify-Storefront-Access-Token":
            "d3021029f8d76cfe263c16528e4fb3b3",
        },
        body: query,
      });
      const filterData = await filtersResponse.json();
      return Promise.resolve(
        filterData.data.collection.products.filters
          .flatMap((filter) => {
            return filter.id == "filter.p.m.filters.years" ? filter.values : [];
          })
          .filter((f) => f.count > 0)
      );
    }
    const filterYearsRaw = await fetchFilters(query);
    const filterYears = filterYearsRaw.filter(value => value.label !== 'NULL');
    if (filterYears.length === 0) {
      yearSelect.disabled = true;
      return;
    }
    yearSelect.innerHTML = '<option value="">Year</option>';
    filterYears.forEach(function (year) {
      var option = document.createElement("option");
      option.value = year.label;
      option.textContent = year.label;
      yearSelect.appendChild(option);
    });
    yearSelect.disabled = false;
  });

document
  .getElementById("search-button")
  .addEventListener("click", function (e) {
    var make = document.getElementById("make_filter").value;
    var model = document.getElementById("model_filter").value;
    var year = document.getElementById("year_filter").value;
    var query = [];

    if (make) query.push(make);
    if (model) query.push(model);
    if (year) query.push(year);
    if (query.length === 3) {
      var form = document.createElement("form");
      form.method = "GET";
      form.action = `/collections/${make}`;
      var modelInput = document.createElement("input");
      modelInput.type = "hidden";
      modelInput.name = "filter.p.m.filters.model";
      modelInput.value = model;
      form.appendChild(modelInput);
      var modelNullInput = document.createElement("input");
      modelNullInput.type = "hidden";
      modelNullInput.name = "filter.p.m.filters.model";
      modelNullInput.value = "NULL";
      form.appendChild(modelNullInput);
      var yearInput = document.createElement("input");
      yearInput.type = "hidden";
      yearInput.name = "filter.p.m.filters.years";
      yearInput.value = year;
      form.appendChild(yearInput);
      var yearNullInput = document.createElement("input");
      yearNullInput.type = "hidden";
      yearNullInput.name = "filter.p.m.filters.years";
      yearNullInput.value = "NULL";
      form.appendChild(yearNullInput);
      document.body.appendChild(form);
      form.submit();
    }
  });

document.getElementById("reset-button").addEventListener("click", function () {
  const makeSelect = document.getElementById("make_filter");
  const modelSelect = document.getElementById("model_filter");
  const yearSelect = document.getElementById("year_filter");

  makeSelect.value = "";
  modelSelect.innerHTML = '<option value="">MODEL</option>';
  modelSelect.disabled = true;
  yearSelect.innerHTML = '<option value="">YEAR</option>';
  yearSelect.disabled = true;
});

const checkFilters = () => {
  const uri = window.location.pathname;
  if (!uri.includes("/collections/")) return;
  if (uri.includes("/collections/all")) return;
  if (uri.includes("/collections/")) {
    const make = uri.split("/")[2];
    const model = new URLSearchParams(window.location.search).get(
      "filter.p.m.filters.model"
    );
    const year = new URLSearchParams(window.location.search).get(
      "filter.p.m.filters.years"
    );
    if (make && model && year) {
      document.getElementById("make_filter").value = make;
      document.getElementById("make_filter").dispatchEvent(new Event("change"));

      const setYearAndDispatch = () => {
        const yearSelect = document.getElementById("year_filter");
        if ([...yearSelect.options].some((opt) => opt.value === year)) {
          yearSelect.value = year;
        } else {
          setTimeout(setYearAndDispatch, 50);
        }
      };

      const setModelAndDispatch = () => {
        const modelSelect = document.getElementById("model_filter");
        if ([...modelSelect.options].some((opt) => opt.value === model)) {
          modelSelect.value = model;
          document
            .getElementById("model_filter")
            .dispatchEvent(new Event("change"));
          setYearAndDispatch();
        } else {
          setTimeout(setModelAndDispatch, 50);
        }
      };
      setModelAndDispatch();
    }
  }
};

document.addEventListener("DOMContentLoaded", checkFilters);
